// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StyledLocalShadow{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #0001;
}

.StyledPopupWrapper{
    background: #FFFFFF;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 24px;
    height: 100%;
    width: 100%;
    /*max-width: 374px;*/
    /*max-height: 500px;*/
    padding: 26px;

    display: flex;
    flex-direction: column;
    gap: 11px;
}

.StyledPopupButton{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFA825;
    border-radius: 24px;
    height: 40px;
    width: 100%;
    max-width: 217px;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}

.StyledIconButton{
    width: 22px;
    height: 22px;
    border: none;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

}

.StyledCloseButton{
    width: 17px;
    height: 17px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}`, "",{"version":3,"sources":["webpack://./src/components/styled/BasicBlocks.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,sDAAsD;IACtD,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;;AAE5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAA+C;AACnD","sourcesContent":[".StyledLocalShadow{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #0001;\n}\n\n.StyledPopupWrapper{\n    background: #FFFFFF;\n    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);\n    border-radius: 24px;\n    height: 100%;\n    width: 100%;\n    /*max-width: 374px;*/\n    /*max-height: 500px;*/\n    padding: 26px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n\n.StyledPopupButton{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #FFA825;\n    border-radius: 24px;\n    height: 40px;\n    width: 100%;\n    max-width: 217px;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 23px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #FFFFFF;\n}\n\n.StyledIconButton{\n    width: 22px;\n    height: 22px;\n    border: none;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n\n}\n\n.StyledCloseButton{\n    width: 17px;\n    height: 17px;\n    background-image: url(\"../../assets/close.svg\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
